import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Icon, Tooltip } from '@dixa/lib-shared-habla';
import { numberFormatterInternational } from '../../../../../app/utils/telephonyHelpers';
import '../../styles/user-item.less';
const UserItem = ({ profile, highlighted, fromNumberFormat, user, canMakeOutBoundCall, makeCall, editUser, userType, }) => {
    let name = '';
    let isNumberShown = false;
    let avatar = _jsx(Avatar, { user: user });
    let callBtn = (_jsx(Tooltip, Object.assign({ content: "Phone number needed - click to edit", dark: true }, { children: _jsx("button", Object.assign({ className: "btn btn-link pull-right", onClick: () => {
                editUser(user);
            } }, { children: _jsx(Icon, { name: "pen" }) })) })));
    const toPhoneNumberFormat = numberFormatterInternational({
        phoneNumber: user.phone_number,
    });
    if (user.phone_number !== null) {
        // The user has a phone number.
        let editUserRender = null;
        // The user is a agent or (admin). Only admins are allowed to edit other agents/admins.
        if (user.roles &&
            (user.roles.indexOf('agent') > -1 || user.roles.indexOf('admin') > -1)) {
            if (profile.roles &&
                Array.isArray(profile.roles) === true &&
                profile.roles.indexOf('admin') > -1) {
                editUserRender = (_jsx(Tooltip, Object.assign({ content: "Click to edit", dark: true }, { children: _jsx("button", Object.assign({ className: "btn btn-link pull-right edit", onClick: () => {
                            editUser(user);
                        } }, { children: _jsx(Icon, { name: "pen" }) })) })));
            }
        }
        else {
            // The user is a enduser and all agent is allowed to edit.
            editUserRender = (_jsx(Tooltip, Object.assign({ content: "Click to edit", dark: true }, { children: _jsx("button", Object.assign({ className: "btn btn-link pull-right edit", onClick: () => {
                        editUser(user);
                    } }, { children: _jsx(Icon, { name: "pen" }) })) })));
        }
        callBtn = (_jsxs("span", Object.assign({ className: "btn-action" }, { children: [_jsx(Tooltip, Object.assign({ content: `Call ${toPhoneNumberFormat} from ${fromNumberFormat}`, dark: true }, { children: _jsx("button", Object.assign({ className: 'btn btn-link pull-right call ' +
                            (canMakeOutBoundCall === false ? 'disabled' : ''), disabled: (canMakeOutBoundCall === false ? 'disabled' : ''), onClick: canMakeOutBoundCall === false
                            ? () => {
                                /** Noop. */
                            }
                            : () => {
                                makeCall(user);
                            } }, { children: "Call" })) })), _jsx("span", Object.assign({ className: userType === 'new' || userType === 'additional_phone_duplicate'
                        ? 'hidden'
                        : '' }, { children: editUserRender }))] })));
    }
    if (user.icon !== undefined) {
        avatar = _jsx(Icon, { className: "s-icon loading-image", name: user.icon });
    }
    if ((typeof user.name === 'string' && user.name.trim().length > 0) ||
        (typeof user.display_name === 'string' &&
            user.display_name.trim().length > 0)) {
        name = typeof user.name === 'string' ? user.name : user.display_name;
    }
    else if (typeof user.phone_number === 'string') {
        name = user.phone_number;
        isNumberShown = true;
    }
    else if (typeof user.email === 'string') {
        name = user.email;
    }
    return (_jsxs("li", Object.assign({ className: 'row-item user ' + (highlighted === true ? 'focused' : '') }, { children: [_jsx("div", Object.assign({ className: "row-item-avatar" }, { children: avatar })), _jsx(Tooltip, Object.assign({ content: name, dark: true }, { children: _jsx("span", Object.assign({ className: "user-name" }, { children: name })) })), _jsx("span", Object.assign({ className: "type" }, { children: isNumberShown === false && user.phone_number !== null
                    ? toPhoneNumberFormat
                    : 'Contact' })), callBtn] })));
};
export default UserItem;
